import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { STORAGE_KEY_ACCESS_TOKEN, UNREG_CHATS_ID } from '../const';
import storageService from '../service/StorageService';
import ToastifyService, { TOAST_NOTIFY_TYPES } from '../service/ToastifyService';
import WSService from '../service/WSService';
import { authUser, fetchUser, setAuthToken, updateUser } from '../store/slices/authSlice';

const useAuth = () => {
    const accessToken = storageService.get(STORAGE_KEY_ACCESS_TOKEN);

    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const jwt = searchParams.get('jwt');
    const error = searchParams.get('error');

    const clearSearchParams = useCallback(() => {
        if (searchParams.has('error')) {
            searchParams.delete('error');
        }
        searchParams.delete('jwt');
        setSearchParams(searchParams, { replace: true });
    }, [searchParams, setSearchParams]);

    useEffect(() => {
        (async () => {
            if (error !== 'null') {
                ToastifyService.setToast(error, TOAST_NOTIFY_TYPES.ERROR, { autoClose: 5000 });
                clearSearchParams();
                return;
            }
            if (!jwt) {
                return;
            }
            await storageService.add(STORAGE_KEY_ACCESS_TOKEN, jwt.toString());
            const unregisterChatIds = await storageService.get(UNREG_CHATS_ID);
            dispatch(authUser()).then(() => {
                if (unregisterChatIds && unregisterChatIds.filter(Boolean).length) {
                    dispatch(
                        updateUser({
                            chats: unregisterChatIds
                        })
                    ).then(() => {
                        storageService.delete(UNREG_CHATS_ID);
                    });
                }
            });
            clearSearchParams();
            await WSService.init();
        })();
    }, [clearSearchParams, dispatch, jwt]);

    useEffect(() => {
        if (!accessToken || jwt) {
            return;
        }

        (async () => {
            dispatch(setAuthToken(accessToken));
            dispatch(fetchUser());

            await WSService.init();
        })();
    }, [accessToken, dispatch, jwt]);
};
export default useAuth;
